// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__STRY8","tabsBox":"styles_tabsBox__3L7It","createButton":"styles_createButton__171TH"};